import styled, { css } from 'styled-components';
import { IKakarikoGridHeaderCellStyleProps } from './types';

export const StyledKakarikoGridHeaderCell = styled.div<IKakarikoGridHeaderCellStyleProps>`
  ${(props: IKakarikoGridHeaderCellStyleProps & { theme: any }) => {
    let { theme, $tableSortable, $textAlignment } = props;

    $textAlignment = $textAlignment || 'center';

    return css`
      --header-background: var(--white-full);
      --sort-icon-color: var(--default-light);
      --border-color: var(--default-light);

      align-items: center;
      background: ${theme.white};
      background: var(--header-background);
      border-bottom-width: 2px;
      border-color: ${theme.defaultLight};
      border: 1px solid var(--border-color);
      cursor: ${$tableSortable ? 'pointer' : 'inherit'};
      display: flex;
      font-size: 12px;
      font-weight: 700;
      height: 52px;
      justify-content: ${$textAlignment};
      padding-left: 9px;

      &.grey {
        --header-background: var(--default-extra-light);
        --sort-icon-color: var(--default-base);
        --border-color: var(--default-light);
      }

      &.dark {
        --header-background: var(--secondary-dark);
        --sort-icon-color: var(--default-base);
        border: 0;
        color: var(--white-full);
      }

      &.disabled {
        cursor: default;

        .data-grid__header-sort {
          opacity: 0.5;
        }
      }

      .data-grid__header-sort {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;

        .MuiSvgIcon-root {
          color: var(--sort-icon-color);
          font-size: 20px;
          margin: -7px 0;

          &:only-child {
            color: var(--black);
          }
        }
      }
    `;
  }}
`;

interface IKakarikoGridHeaderStyleProps {
  ref: any;
}

export const StyledKakarikoGridHeader = styled.div<IKakarikoGridHeaderStyleProps>`
  display: contents;
`;
